// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_jx-0";